import api from '@/api'
import files from 'file-saver'
import {getHeaderName, objectTrim} from '@/utils'
import {
  SET_ACTIVITY_DETAIL_LIST,
  SET_ACTIVITY_DETAIL_LIST_PAGE_TOTAL,
  SET_ACTIVITY_DETAIL_LIST_PAGE_NUM,
  SET_ACTIVITY_DETAIL_LIST_PAGE_SIZE,
  SET_ACTIVITY_DETAIL_LIST_QUERY,
  SET_ACTIVITY_DETAIL_TOTALAVALIABLE,
  SET_ACTIVITY_DETAIL,
  SET_ACTIVITY_DETAIL_SEARCHING,
  SET_ACTIVITY_DETAIL_EXPORTING,
} from './mutation-types'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  activityId: '',
  userName: '',
  userId: '',
  status: '',
  bonusCode: '',
})

const state = {
  searching: false,
  exporting: false,
  initQuery: initQuery(),
  detail: {},
  activityDetail: {
    list: [],
    listPageTotal: 0,
    totalAvailable: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_ACTIVITY_DETAIL_LIST] (state, payload) {
    state.activityDetail.list = payload
  },
  [SET_ACTIVITY_DETAIL_LIST_PAGE_TOTAL] (state, payload) {
    state.activityDetail.listPageTotal = payload
  },
  [SET_ACTIVITY_DETAIL_LIST_PAGE_NUM] (state, payload) {
    state.activityDetail.query.pageNum = payload
  },
  [SET_ACTIVITY_DETAIL_LIST_PAGE_SIZE] (state, payload) {
    state.activityDetail.query.pageSize = payload
  },
  [SET_ACTIVITY_DETAIL_LIST_QUERY] (state, payload) {
    state.activityDetail.query = {
      ...state.activityDetail.query,
      ...payload,
    }
  },
  [SET_ACTIVITY_DETAIL_TOTALAVALIABLE] (state, payload) {
    state.activityDetail.totalAvailable = payload
  },
  [SET_ACTIVITY_DETAIL] (state, payload) {
    state.detail = payload
  },
  [SET_ACTIVITY_DETAIL_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_ACTIVITY_DETAIL_EXPORTING] (state, payload) {
    state.exporting = payload
  },
}

const actions = {
  async queryRecords ({commit, state}, payload) {
    try {
      let params = {
        ...payload,
        ...objectTrim(state.activityDetail.query),
      }
      const {data: {items, total}} = await api.deployApi.queryRecords(params)
      commit(SET_ACTIVITY_DETAIL_SEARCHING, false)
      commit(SET_ACTIVITY_DETAIL_LIST, items.items)
      commit(SET_ACTIVITY_DETAIL_TOTALAVALIABLE, items.totalAvailable)
      commit(SET_ACTIVITY_DETAIL_LIST_PAGE_TOTAL, total)
    } catch (error) {
      commit(SET_ACTIVITY_DETAIL_SEARCHING, false)
      commit(SET_ACTIVITY_DETAIL_LIST, [])
      commit(SET_ACTIVITY_DETAIL_LIST_PAGE_TOTAL, 0)
    }
  },
  async queryByid ({commit}, payload) {
    const {data} = await api.deployApi.queryByid(payload)
    commit('SET_ACTIVITY_DETAIL', data)
  },
  // async updateList ({commit, dispatch}, {pageNum}) {
  //   commit('SET_ACTIVITY_DETAIL_LIST_PAGE_NUM', pageNum)
  //   dispatch('queryRecords')
  // },
  setPageNum ({commit, dispatch}, payload) {
    commit('SET_ACTIVITY_DETAIL_LIST_PAGE_NUM', payload)
    // dispatch('updateList', {pageNum: payload})
  },
  setPageSize ({commit, dispatch}, payload) {
    commit('SET_ACTIVITY_DETAIL_LIST_PAGE_NUM', 1)
    commit('SET_ACTIVITY_DETAIL_LIST_PAGE_SIZE', payload)
    // dispatch('updateList', {pageNum: 1})
  },
  setPageQuery ({commit, dispatch}, payload) {
    commit('SET_ACTIVITY_DETAIL_LIST_QUERY', payload)
    // dispatch('updateList', {pageNum: 1})
  },
  changeCouponQuery ({commit, dispatch}, payload) {
    commit(SET_ACTIVITY_DETAIL_SEARCHING, true)
    dispatch('queryRecords')
  },
  async exportExcelByCondition ({commit, state}, payload) {
    const query = {
      ...objectTrim(state.activityDetail.query),
      ...payload,
    }
    try {
      commit(SET_ACTIVITY_DETAIL_EXPORTING, true)
      const {data, headers} = await api.deployApi.exportExcelByCondition(query)
      commit(SET_ACTIVITY_DETAIL_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/zip' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_ACTIVITY_DETAIL_EXPORTING, false)
    }
  },
  async addBonus ({dispatch, state}, payload) {
    const data = await api.deployApi.addBonus(payload)
    if (data.result && data.code === 200) dispatch('queryRecords', { activityId: payload.id })
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
